export class BaseHttpRequest {
    constructor(config) {
        this.config = config;
    }
}
